<template>
  <div id="team">
    <template v-if="team">
      <div class="header">
        <div class="team">
          <cld-image
            class="logo"
            :publicId="team.shield"
            type="fetch"
            loading="lazy"
          >
            <cld-transformation
              height="100"
              radius="3"
              crop="fill"
              fetchFormat="auto"
            />
          </cld-image>
          <div class="category">{{ team.category.name }}</div>
          <div class="name">{{ team.name }}</div>
        </div>
      </div>
      <div class="topbar">
        <div class="item" :class="{ selected: page == 1 }" @click="select(1)">
          {{ $t("miclive.team.matches") }}
        </div>
        <div class="item" :class="{ selected: page == 2 }" @click="select(2)">
          {{ $t("miclive.team.squad") }}
        </div>
        <div class="item" :class="{ selected: page == 3 }" @click="select(3)">
          {{ $t("miclive.team.teams") }}
        </div>
      </div>
    </template>

    <div class="content">
      <template v-if="page == 1">
        <template v-if="matches">
          <div class="matches">
            <Match
              v-for="match in matches"
              :item="match"
              :key="match.id"
            ></Match>
          </div>
        </template>
        <template v-else>
          <div class="loader"></div>
        </template>
      </template>
      <template v-else-if="page == 2">
        <Player
          v-for="item in team.players"
          :key="item.id"
          :item="item"
          :staff="false"
        ></Player>
        <Player
          v-for="item in team.staff"
          :key="item.id"
          :item="item"
          :staff="true"
        ></Player>
      </template>
      <template v-if="page == 3">
        <div class="teams">
          <router-link
            v-for="team in club.teams"
            :key="team.id"
            :to="'/team/' + team.id"
            class="item"
            >{{ team.name }} <b>{{ team.category }}</b></router-link
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";

import Match from "@/components/domain/competition/match";
import Player from "@/components/domain/competition/player";
const api = new Api();

export default {
  name: "Team",
  components: {
    Match,
    Player
  },
  data() {
    return {
      club: false,
      team: false,
      matches: false,
      page: 1
    };
  },
  computed: {},
  methods: {
    load() {
      this.page = 1;
      var self = this;
      if (this.$route.params.id) {
        this.matches = false;

        var teamId = this.$route.params.id;
        api.post("miclive/team/" + teamId, {}).then(function(data) {
          self.team = data.data;

          var clubId = self.team.club_id;
          api.post("miclive/clubs/" + clubId, {}).then(function(data) {
            self.club = Object.values(data.data)[0];
          });
        });
        var params = {
          team_id: teamId
        };
        api.post("miclive/matches", params).then(function(data) {
          self.matches = data.data;
        });
      }
    },
    select(page) {
      this.page = page;
    }
  },
  created() {
    // this.load();
  },
  watch: {
    "$route.params": {
      handler: function(newValue, value) {
        this.load();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
#team {
  padding-bottom: 60px;

  .header {
    background-color: #fff;
    border-radius: 4px;
    padding: 15px 5px;
    width: 100%;
    margin-bottom: 10px;
    align-items: center;
    text-decoration: none;
    color: #222;
    position: fixed;
    top: 60px;
    left: 0;
    height: 200px;

    .team {
      width: 100%;
      text-align: center;
      align-items: center;

      .logo {
        width: 80%;
        max-width: 85px;
      }
      .name {
        font-family: $font-title;
        color: #222;
        color: $main-color;
        font-size: 18px;
        margin-top: 5px;
        height: 40px;
      }
      .category {
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }

  .topbar {
    background-color: #fff;
    padding: 15px;
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
    align-items: center;
    text-decoration: none;
    color: #222;
    position: fixed;
    top: 260px;
    left: 0;
    height: 45px;
    background-color: $secondary-color;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    .item {
      text-transform: uppercase;
      font-size: 12px;
      padding: 0 5px;
      text-decoration: none;
      color: #222;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;

      &.selected,
      &:hover {
        font-family: $font-title;
      }
    }
  }

  .content {
    padding-top: 250px;

    .matches {
      display: grid;
      grid-gap: 10px;
      grid-template-columns: minmax(0, 1fr);
    }

    .squad {
      padding: 0px;
      width: 100%;
      overflow: hidden;

      .half {
        width: 49%;
        float: left;
        margin-bottom: 10px;
        overflow: hidden;

        .player {
          background-color: #fff;
          border-radius: 4px;
          margin-bottom: 3px;
          font-size: 12px;
          padding: 8px;
          width: 100%;
          border-left: 5px solid $main-color;
          //   display: flex;
          //   align-items: center;

          .number {
          }
          .name {
            white-space: nowrap;
            text-overflow: ellipsis;
            display: block;
            width: 100%;
            color: #222;
            b {
              font-family: $font-title;
            }
          }
          .position {
            width: 100%;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #666;
          }

          &.staff {
          }
        }
        &.away {
          float: right;
          text-align: right;

          .player {
            border-right: 5px solid #ff5722;
            border-left: none;
          }
        }
      }
    }

    .teams {
      .item {
        width: 100%;
        background-color: #fff;
        border-radius: 4px;
        padding: 15px;
        text-decoration: none;
        color: #222;

        background: url("~@/../public/img/left_arrow.svg") no-repeat center
          right 10px #fff;
        width: 100%;
        display: block;
        margin-bottom: 10px;
        background-size: 20px;
        font-size: 12px;

        b {
          display: block;
          font-family: $font-title;
          font-size: 16px;
        }
      }
    }
  }
}

.tablet {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.desktop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
</style>
